module.exports = __webpack_public_path__ + "img/finace.ce167693.svg";